import React from "react";
import Index from "../_components/ReviewMangement/Index";

function ReviewManagement() {
  return (
    <div className="container">
      <Index />
    </div>
  );
}

export default ReviewManagement;
